export const names = {
    oils: 'Oil',
    heavyoil: 'Heavy fuel oil',
    lightoil: 'Light fuel oil',
    transportoil: 'Transport fuels',
    coal: 'Coal',
    naturalgas: 'Natural gas',
    industryreactions: 'Industry reactions',
    peat: 'Peat',
    otherfossil: 'Other fossil fuels',
    wood: 'Wood',
    otherbio: 'Other non-fossil fuels',
    nuclear: 'Nuclear energy',
    hydro: 'Hydro power',
    wind: 'Wind power',
    heatpumps: 'Heat pumps',
    electricityimport: 'Electricity import',
    other: 'Recycled sources',
    gasoline: 'Gasoline',
    biogasoline: 'Gasoline bio component',
    diesel: 'Diesel',
    biodiesel: 'Biodiesel',
    lpg: 'Propane',
    otheroils: 'Other oils',
    woodsmall: 'Wood small-scale',
    woodindustry: 'Wood industrial',
    recoveredfossil: 'Fossil waste',
    recoveredbio: 'Non-fossil waste',
    biogas: 'Biogas',
    solar: 'Solar energy',
    hydrogen: 'Hydrogen'
}
